@if (episodeItem()) {
    @if (showBadge()) {
        <div class="badge-container">
            <badge [badge]="episodeItem().badge" [variant]="BadgeVariant.Episode"
                [availabilityStartTime]="episodeItem().availabilityStartTime"
                [availabilityEndTime]="episodeItem().availabilityEndTime"
                [hasUpcomingEnabled]="hasUpcomingEnabled()"
                [hasOutgoingEnabled]="hasOutgoingEnabled()"
                [showAutomaticBadge]="showAutomaticBadge()"
                (availabilityStartPassed)="onAvailabilityStartPassed($event)"></badge>
        </div>

    }
    <div (click)="inPlayer() ? play() : null" class="content-item" [class.opened]="opened()" [class.inPlayer]="inPlayer()" [class.active]="episodeItem().active">
        <div class="media-wrapper" (click)="!inPlayer() && showPlayButton() ? play() : null" [transcodeImage]="episodeItem()?.posterLandscape">
            @if (restricted()) {
                <content-rating-lock />
            }
            @if (showPlayButton()) {
                <rounded-icon-button class="media-play"
                [imgSrc]="skinning.getImage('icon_play')"></rounded-icon-button>
            }
            <div class="media-progress-bar">
                <div class="media-progress-fill" data-testid="episode-card_progress" [style.width.%]="episodeItem().bookmarkPercentage"></div>
            </div>
        </div>
        <div class="content-info"  (click)="!inPlayer() ? expandEpisode() : null">
            <div class="media-header">
                <div class="media-title">{{ restricted() ? ('common.protected_content_title' | transloco) : episodeItem().title }}</div>
                @if (!inPlayer()) {
                    <div class="action-buttons">
                        @if (opened() && auth.isAuthenticated()) {
                            <img class="media-favorite" [src]="episodeItem().watchLater ? skinning.getImage('icon_favorites_added') : skinning.getImage('icon_favorites')" alt="Favorite" (click)="toggleFavorite(episodeItem(), $event)">
                        }
                        <img class="media-arrow" src="{{skinning.getImage('arrow_primary')}}" alt="Arrow">
                    </div>
                }
            </div>
            @if (!inPlayer()) {
                <div class="media-description" #descRef>{{episodeItem().description}}</div>
                @if (checkAnyCredits()) {
                    <span class="credits-holder">
                        @if (episodeItem().credits?.actors) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.actors, 'credits.actor', 'credits.actors') }}:</span>
                            {{ episodeItem().credits?.actors }}
                        </div>
                        }
                        @if (episodeItem().credits?.directors) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.directors, 'credits.director', 'credits.directors') }}:</span>
                            {{ episodeItem().credits?.directors }}
                        </div>
                        }
                        @if (episodeItem().credits?.authors) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.authors, 'credits.author', 'credits.authors') }}:</span>
                            {{ episodeItem().credits?.authors }}
                        </div>
                        }
                        @if (episodeItem().credits?.writers) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.writers, 'credits.writer', 'credits.writers') }}:</span>
                            {{ episodeItem().credits?.writers }}
                        </div>
                        }
                        @if (episodeItem().credits?.producers) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.producers, 'credits.producer', 'credits.producers') }}:</span>
                            {{ episodeItem().credits?.producers }}
                        </div>
                        }
                        @if (episodeItem().credits?.editors) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.editors, 'credits.editor', 'credits.editors') }}:</span>
                            {{ episodeItem().credits?.editors }}
                        </div>
                        }
                        @if (episodeItem().credits?.projectEditors) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.projectEditors, 'credits.project_editor', 'credits.project_editors') }}:</span>
                            {{ episodeItem().credits?.projectEditors }}
                        </div>
                        }
                        @if (episodeItem().credits?.publishers) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.publishers, 'credits.publisher', 'credits.publishers') }}:</span>
                            {{ episodeItem().credits?.publishers }}
                        </div>
                        }
                        @if (episodeItem().credits?.productionCountries) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.productionCountries, 'credits.country', 'credits.countries') }}:</span>
                            {{ episodeItem().credits?.productionCountries }}
                        </div>
                        }
                        @if (episodeItem().credits?.photoSources) {
                        <div class="credits">
                            <span>{{ checkPlural(episodeItem().credits?.photoSources, 'credits.photography_source', 'credits.photography_source') }}:</span>
                            {{ episodeItem().credits?.photoSources }}
                        </div>
                        }

                    </span>
                }
            }


            <div class="info">
                @if (converter.formatAssetDurationToTime(episodeItem()); as durationLabel) {
                    <div data-testid="episode-card_duration">
                        <img class="me-2" src="{{skinning.getImage('icon_duration')}}">{{durationLabel}}
                    </div>
                }
                @if (episodeItem().contentRating) {
                    <div>
                        <img class="me-2" src="{{skinning.getImage('icon_pg')}}">{{episodeItem().contentRating}}
                    </div>
                }
                @if (episodeItem().productionYear) {
                    <div>{{episodeItem().productionYear}}</div>
                }
                @if (opened() && !inPlayer()) {
                    <div>{{episodeItem().categories.join(', ')}}</div>
                }
               
                @if (opened() && episodeItem().geoblockAreaLocalization) {
                    <div class="geoblocked-areas">{{episodeItem().geoblockAreaLocalization}}</div>
                }
                
            </div>
        </div>
    </div>
}
@if (extrasItem()) {
    <div class="content-item" (click)="play()">
        <div class="media-wrapper" [transcodeImage]="extrasItem().posterLandscape">
            <rounded-icon-button class="media-play"
                [imgSrc]="skinning.getImage('icon_play')"></rounded-icon-button>
        </div>
        <div class="content-info center">
            <div class="media-description">{{extrasItem().title}}</div>
        </div>
    </div>
}
